import { getDefaultStore } from 'jotai';
import { FeatureFlagsAtom } from './atoms';

export const hasFeatureFlag = (name: string) => {
  const store = getDefaultStore();
  return store.get(FeatureFlagsAtom)?.[name];
};
